/** Occurrence days match the existing America/Sao_Paulo unique index. */
export const CHECKIN_DAY_BASIS = "America/Sao_Paulo" as const;
const formatter = new Intl.DateTimeFormat("en-CA", { timeZone: CHECKIN_DAY_BASIS, year: "numeric", month: "2-digit", day: "2-digit" });
export function checkInDayKey(value: Date | string | number = new Date()): string | null {
  const date = value instanceof Date ? value : new Date(value);
  if (!Number.isFinite(date.getTime())) return null;
  const parts = formatter.formatToParts(date), part = (type: string) => parts.find(p => p.type === type)?.value;
  return `${part("year")?.padStart(4, "0")}-${part("month")}-${part("day")}`;
}
export function validCheckInDay(value: unknown): value is string {
  if (typeof value !== "string" || value.startsWith("0000-") || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;
  const date = new Date(value + "T12:00:00.000Z");
  return Number.isFinite(date.getTime()) && date.toISOString().slice(0, 10) === value;
}
export function shiftCheckInDay(day: string, delta: number): string {
  if (!validCheckInDay(day) || !Number.isInteger(delta)) throw new Error("invalid_checkin_day");
  const date = new Date(day + "T12:00:00.000Z"); date.setUTCDate(date.getUTCDate() + delta); return date.toISOString().slice(0, 10);
}
/** First instant belonging to a civil day, including historical midnight DST. */
function dayStart(day: string): number {
  const noon = Date.parse(day + "T12:00:00.000Z"); let lo = noon - 36 * 3600000, hi = noon + 36 * 3600000;
  while (lo < hi) { const mid = Math.floor((lo + hi) / 2); if ((checkInDayKey(mid) ?? "") < day) lo = mid + 1; else hi = mid; }
  if (checkInDayKey(lo) !== day) throw new Error("invalid_checkin_day"); return lo;
}
export function checkInDayWindowForDay(day: string): { start: string; end: string } {
  if (!validCheckInDay(day)) throw new Error("invalid_checkin_day");
  return { start: new Date(dayStart(day)).toISOString(), end: new Date(dayStart(shiftCheckInDay(day, 1))).toISOString() };
}
export function checkInDayWindow(now: Date): { start: string; end: string } {
  const day = checkInDayKey(now); if (!day) throw new Error("invalid_checkin_day"); return checkInDayWindowForDay(day);
}
export function checkInWeekday(day: string): number { if (!validCheckInDay(day)) throw new Error("invalid_checkin_day"); return new Date(day + "T12:00:00Z").getUTCDay(); }
/** Calendar proxy for the shared local-calendar analytics engine; never persisted. */
export function checkInAnalyticsTime(value: Date | string | number): number | null {
  const day = checkInDayKey(value); return day ? new Date(day + "T12:00:00").getTime() : null;
}
export function checkInEnergyLabel(value: number | null | undefined): string {
  if (value == null || !Number.isFinite(value) || value < 1 || value > 5) return "home.glance.empty";
  return value >= 4 ? "home.glance.high" : value === 3 ? "home.glance.mid" : "home.glance.low";
}
